module.exports = __webpack_public_path__ + "static/media/img_man_annimation4.4bf76e06.gif";